export default __webpack_public_path__ + "static/media/chart.d231fc07.svg";